/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SentryTestRouteImport } from './routes/sentry-test'
import { Route as NeedsDriverRouteImport } from './routes/needs-driver'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HelpRouteImport } from './routes/help'
import { Route as CalendarRouteImport } from './routes/calendar'
import { Route as AppointmentsRouteImport } from './routes/appointments'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as IndexRouteImport } from './routes/index'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SentryTestRoute = SentryTestRouteImport.update({
  id: '/sentry-test',
  path: '/sentry-test',
  getParentRoute: () => rootRouteImport,
} as any)
const NeedsDriverRoute = NeedsDriverRouteImport.update({
  id: '/needs-driver',
  path: '/needs-driver',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarRoute = CalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const AppointmentsRoute = AppointmentsRouteImport.update({
  id: '/appointments',
  path: '/appointments',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/appointments': typeof AppointmentsRoute
  '/calendar': typeof CalendarRoute
  '/help': typeof HelpRoute
  '/login': typeof LoginRoute
  '/needs-driver': typeof NeedsDriverRoute
  '/sentry-test': typeof SentryTestRoute
  '/settings': typeof SettingsRoute
  '/users': typeof UsersRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/appointments': typeof AppointmentsRoute
  '/calendar': typeof CalendarRoute
  '/help': typeof HelpRoute
  '/login': typeof LoginRoute
  '/needs-driver': typeof NeedsDriverRoute
  '/sentry-test': typeof SentryTestRoute
  '/settings': typeof SettingsRoute
  '/users': typeof UsersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/appointments': typeof AppointmentsRoute
  '/calendar': typeof CalendarRoute
  '/help': typeof HelpRoute
  '/login': typeof LoginRoute
  '/needs-driver': typeof NeedsDriverRoute
  '/sentry-test': typeof SentryTestRoute
  '/settings': typeof SettingsRoute
  '/users': typeof UsersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/analytics'
    | '/appointments'
    | '/calendar'
    | '/help'
    | '/login'
    | '/needs-driver'
    | '/sentry-test'
    | '/settings'
    | '/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/analytics'
    | '/appointments'
    | '/calendar'
    | '/help'
    | '/login'
    | '/needs-driver'
    | '/sentry-test'
    | '/settings'
    | '/users'
  id:
    | '__root__'
    | '/'
    | '/analytics'
    | '/appointments'
    | '/calendar'
    | '/help'
    | '/login'
    | '/needs-driver'
    | '/sentry-test'
    | '/settings'
    | '/users'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AnalyticsRoute: typeof AnalyticsRoute
  AppointmentsRoute: typeof AppointmentsRoute
  CalendarRoute: typeof CalendarRoute
  HelpRoute: typeof HelpRoute
  LoginRoute: typeof LoginRoute
  NeedsDriverRoute: typeof NeedsDriverRoute
  SentryTestRoute: typeof SentryTestRoute
  SettingsRoute: typeof SettingsRoute
  UsersRoute: typeof UsersRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sentry-test': {
      id: '/sentry-test'
      path: '/sentry-test'
      fullPath: '/sentry-test'
      preLoaderRoute: typeof SentryTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/needs-driver': {
      id: '/needs-driver'
      path: '/needs-driver'
      fullPath: '/needs-driver'
      preLoaderRoute: typeof NeedsDriverRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar': {
      id: '/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof CalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/appointments': {
      id: '/appointments'
      path: '/appointments'
      fullPath: '/appointments'
      preLoaderRoute: typeof AppointmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AnalyticsRoute: AnalyticsRoute,
  AppointmentsRoute: AppointmentsRoute,
  CalendarRoute: CalendarRoute,
  HelpRoute: HelpRoute,
  LoginRoute: LoginRoute,
  NeedsDriverRoute: NeedsDriverRoute,
  SentryTestRoute: SentryTestRoute,
  SettingsRoute: SettingsRoute,
  UsersRoute: UsersRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
